import React, { useEffect } from "react";
import Alert from "@mui/material/Alert";
import Button from "@mui/material/Button";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import Drawer from "./../../components/Drawer";
import ApiCommonContent from "../../services/GenericContent";
import { useNavigate } from "react-router-dom";
import "./styles.scss";
import Logo from "./../../assets/images/generic/logoZoom.jpg";
import JugarMaquina from "./../../assets/images/board/Icon_JugarMaquina.png";
import JugarSola from "./../../assets/images/board/Icon_JugarSola.png";
import curvaIzq from "./../../assets/images/board/curvaIzquierda_ModoJuego.png";
import curvaDer from "./../../assets/images/board/curvaDerecha_ModoJuego.png";
import { CommonContent, ContentKey } from "../../types/Types";
import GameModeSkeleton from "../../components/Skeleton/GameModeSkeleton";
import UserSession from "./../../services/UserSession";
import CircularAvarar from "./../../components/CircularAvarar";
import { GameMode, UserAccount } from "../../types/Game";
import GameHelper from "../../services/GameHelper";
import PopupLoading from "./../../components/PopupLoading";
import { Session } from "inspector";

type HeaderApp = {
  title: string;
  avatar: string;
  badgeContent?: number;
};
const HeaderAppBar = (props: HeaderApp) => {
  const navigate = useNavigate();
  const handleClick = () => {
    navigate("/myprofile");
  };
  return (
    <Box sx={{ flexGrow: 1 }}>
      <AppBar position="static" className="topBar">
        <Toolbar>
          <Drawer />
          <Typography
            variant="h6"
            component="div"
            sx={{ flexGrow: 1 }}
            className="textMenu"
          >
            {props.title}
          </Typography>
          <CircularAvarar
            badgeContent={props.badgeContent}
            onClick={handleClick}
            width={50}
            height={50}
            url={props.avatar}
          />
        </Toolbar>
      </AppBar>
    </Box>
  );
};

const GameModeScreen = () => {
  let joinedGame = false;
  const navigate = useNavigate();

  const checkSesson = async () => {
    const isUserLoggedIn = await UserSession.isUserLoggedIn();
    if (!isUserLoggedIn) {
      navigate("/");
    }

    const gameId = await GameHelper.getCurrentGameId();
    if (gameId && joinedGame === false) {
      joinedGame = true;
      await GameHelper.joinToGame();
      navigate(`/game`, { replace: true });
    }
  };

  const [createGame, setCreateGame] = React.useState(false);
  const [gameModeLabel, setGameModeLabel] = React.useState("...");
  const [profile, setProfile] = React.useState<UserAccount | null>(null);
  const [commonContent, setCommonContent] = React.useState<
    CommonContent[] | undefined
  >(undefined);

  useEffect(() => {
    if (!commonContent) {
      ApiCommonContent.getContent().then((content) => {
        console.log(content);
        setCommonContent(content);
      });
    }
  });

  useEffect(() => {
    if (!profile) {
      UserSession.getSession()
        .then((user) => {
          console.log("Profile:", user);
          setProfile(user);
        })
        .catch((e) => console.error(e));
    }
  }, [profile]);

  useEffect(() => {
    if (!profile) {
      checkSesson();
    }
  }, [profile]);

  const handleClick = async (mode: GameMode) => {
    try {
      setCreateGame(true);
      const { gameId } = await GameHelper.createGame(mode);
      setCreateGame(false);
      navigate(`/game/?gameId=${gameId}`, { replace: true });
    } catch (e) {
      console.error(e);
      await UserSession.endSession()
      navigate(`/`);
    }
  };

  return (
    <div className="contenedorGameMode">
      {!commonContent || (commonContent?.length <= 0 && <GameModeSkeleton />)}
      {commonContent && commonContent?.length > 0 && profile && (
        <>
          <HeaderAppBar
            badgeContent={profile.points}
            title={ApiCommonContent.getKeyValue(commonContent, ContentKey.MENU)}
            avatar={profile.profileUrl}
          />
          <div className="">
            <img className="homeLogo" src={Logo}></img>
            <div className="gameModeContainer">
              <div className="gameModeColumn" style={{ textAlign: "right" }}>
                <div>
                  <img src={JugarMaquina} />
                </div>
                <Button
                  onClick={() => {
                    handleClick(GameMode.PlayWithFriends);
                    setGameModeLabel(
                      ApiCommonContent.getKeyValue(
                        commonContent,
                        ContentKey.PLAY_WITH_FRIENDS
                      )
                    );
                  }}
                  variant="contained"
                >
                  {ApiCommonContent.getKeyValue(
                    commonContent,
                    ContentKey.PLAY_WITH_FRIENDS
                  )}
                </Button>
              </div>
              <div className="gameModeColumn" style={{ textAlign: "left" }}>
                <div>
                  <img src={JugarSola} />
                </div>
                <Button
                  onClick={() => {
                    handleClick(GameMode.PlayAlone);
                    setGameModeLabel(
                      ApiCommonContent.getKeyValue(
                        commonContent,
                        ContentKey.PLAY_ALONE
                      )
                    );
                  }}
                  variant="contained"
                >
                  {ApiCommonContent.getKeyValue(
                    commonContent,
                    ContentKey.PLAY_ALONE
                  )}
                </Button>
              </div>
            </div>

            <div className="labelModeContainer">
              <div style={{ textAlign: "right" }}>
                <img width={45} src={curvaIzq} />
              </div>
              <div className="labelText">
                {" "}
                {ApiCommonContent.getKeyValue(
                  commonContent,
                  ContentKey.GAME_MODE_DESCRIPTION
                )}{" "}
              </div>
              <div style={{ textAlign: "left" }}>
                <img width={45} src={curvaDer} />
              </div>
            </div>
            <div className="alertModeContainer">
              <Alert
                variant="filled"
                severity="success"
                className="alertModeContainerText"
              >
                {ApiCommonContent.getKeyValue(
                  commonContent,
                  ContentKey.WELCOME
                )}{" "}
                {profile.name}
                {"!"}
              </Alert>
              <PopupLoading
                title={gameModeLabel}
                visible={createGame}
                description=""
              />
            </div>
          </div>
        </>
      )}
    </div>
  );
};
export default GameModeScreen;
